import React from "react";
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import { CmpDatePicker } from "../../../Component/Common/ToolBox/ToolBox";

const HeaderComponent = ({
  handleAddNew = () => {},
  status,
  handleLoadBtn = () => {},
  filterState,
  setFilterState,
  vRdxDBLocation = [],
}) => {
  // Media Queries for Responsiveness
  const isMobile = useMediaQuery("(max-width:650px)");
  const isTabOrDesktop = !isMobile;

  const handleStatusChange = (event) => {
    setFilterState((prev) => ({
      ...prev,
      status: event.target.value,
    }));
  };

  return (
    <div className="stock-detail">
      <Grid
        container
        columnSpacing={{ xs: 1, sm: 1.5, md: 2, lg: 4 }}
        rowSpacing={{ xs: 1.5, sm: 1, md: 2, lg: 2 }}
        marginTop={{ xs: 0.5, sm: 0.5, md: 1, lg: 1 }}
      >
        <Grid item xs={12} sm={3} md={2}>
          <Typography>From Date</Typography>
          <CmpDatePicker
            xValue={filterState.dateFrom}
            xOnChange={(newValue) =>
              setFilterState((obj) => ({
                ...obj,
                dateFrom: newValue.$d,
              }))
            }
            xName={"dateFrom"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <Typography>To Date</Typography>
          <CmpDatePicker
            style={{ width: "100% !important" }}
            xValue={filterState.dateTo}
            xOnChange={(newValue) =>
              setFilterState((obj) => ({
                ...obj,
                dateTo: newValue.$d,
              }))
            }
            xName={"dateTo"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3.5}>
          <Typography>Location</Typography>

          <Autocomplete
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            options={vRdxDBLocation} // Use full objects
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.Name1
            } // Support free text input
            value={
              vRdxDBLocation.find((loc) => loc.Uid === filterState.location) ||
              null
            }
            onChange={(event, newValue) => {
              if (typeof newValue === "string") {
                setFilterState((prev) => ({
                  ...prev,
                  location: newValue, // Store typed value
                }));
              } else if (newValue) {
                setFilterState((prev) => ({
                  ...prev,
                  location: newValue.Uid, // Store UID when selecting from dropdown
                }));
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                slotProps={{
                  input: {
                    ...params.InputProps,
                    type: "search",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography>Status</Typography>
          <FormControl fullWidth>
            <Select
              value={filterState?.status}
              name="status"
              onChange={handleStatusChange}
            >
              {status.map((sts) => (
                <MenuItem key={sts} value={sts}>
                  {sts}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/* <Grid item xs={12} sm={4} md={3}>
          <Typography> Count Status</Typography>
          <FormControl fullWidth>
            <Select
              value={filterState?.countStatus}
              name="countStatus"
              onChange={handleCountStatusChange}
            >
              {status.map((sts) => (
                <MenuItem key={sts} value={sts}>
                  {sts}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <Typography> Variance Status</Typography>
          <FormControl fullWidth>
            <Select
              value={filterState?.varianceStatus}
              name="varianceStatus"
              onChange={handleVarStatusChange}
            >
              {status.map((sts) => (
                <MenuItem key={sts} value={sts}>
                  {sts}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography>Final Posting</Typography>
          <FormControl fullWidth>
            <Select
              value={filterState?.finalPosting}
              name="finalPosting"
              onChange={handlePostChange}
            >
              {status.map((sts) => (
                <MenuItem key={sts} value={sts}>
                  {sts}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
        <Grid
          item
          xs={12}
          sm={8}
          md={2.5}
          display={isMobile ? "" : "flex"}
          justifyContent={isMobile ? "center" : "flex-end"}
          textAlign={isMobile ? "center" : "flex-end"}
          gap={2}
        >
          <Button
            variant="contained"
            sx={{
              width: isMobile ? "80px" : "100px",
              mt: isMobile ? 1 : 2,
              textTransform: "capitalize",
            }}
            onClick={handleLoadBtn}
          >
            Load
          </Button>
          {isTabOrDesktop && (
            <Button
              variant="contained"
              sx={{
                width: "100px",
                mt: isMobile ? "0px !important" : 2,
                textTransform: "capitalize",
              }}
              onClick={handleAddNew}
            >
              New
            </Button>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default HeaderComponent;
